import { useTheme } from ".";
import createStyled, { skipProps } from "@suid/system/createStyled";
export const skipRootProps = [...skipProps, "classes"];
export default createStyled({
    onUseTheme: () => useTheme(),
});
